// extracted by mini-css-extract-plugin
export default {"root":"yB1Tz8","checkbox":"HzInEa","checkboxError":"Aj7jb6"};